<div  class="container mt-5" *ngIf="auth.userProfile$ | async as profile"> 
  <mat-card>    
    <mat-card-content>
      <br />
      <div class="row align-items-center profile-header mb-5 text-center text-md-left">
        <div class="col-md-2">
          &nbsp;
          <img [src]="profile.picture"
               class="rounded-circle img-fluid profile-picture mb-3 mb-md-0" />
        </div>
        <div class="col-md">
          <h2>Name/Email:   {{ profile.name }}</h2>
          <h2>Roles:        {{ roles==""?"N/A":roles }}</h2>
          <h2>Institution Colleges:        {{ institutioncolleges==""?"N/A":institutioncolleges }}</h2>
          <h2>Assigned Sports:        {{ assignedsports==""?"N/A":assignedsports }}</h2>
          <div *ngIf="true">
              <button class="nav-link text-dark" mat-icon-button id="theme-selector" 
                [mat-menu-trigger-for]="themeMenu"
               matTooltip="Select a theme!">
                <mat-icon class="auto-flip">format_color_fill</mat-icon>
              </button>
              <mat-menu #themeMenu>
                <button (click)="applyTheme(styleObj.lsu)" mat-menu-item>LSU</button>
                <button (click)="applyTheme(styleObj.invested)" mat-menu-item>Invested</button>
                <button (click)="applyTheme(styleObj.RichElectricBlue)" mat-menu-item>Rich Electric Blue</button>
                <button (click)="applyTheme(styleObj.Royalbluepeach)" mat-menu-item>Royal blue & peach</button>
                <button (click)="applyTheme(styleObj.Bluepink)" mat-menu-item>Blue & pink</button>
                <button (click)="applyTheme(styleObj.Charcoalyellow)" mat-menu-item>Charcoal & yellow</button>
                <button (click)="applyTheme(styleObj.SimmonsUniversity)" mat-menu-item>Simmons University</button>
                <!-- <button mat-menu-item>Red & yellowk</button>
                <button mat-menu-item>Lime green & electric blue</button>
                <button mat-menu-item>Lavender & teal</button>
                <button mat-menu-item>Cherry red & off-white</button>
                <button mat-menu-item>Baby blue & white</button>
                <button mat-menu-item>Hot pink & cyan</button>
                <button mat-menu-item>Peach & burnt orangek</button>
                <button mat-menu-item>Light blue & dark blue</button>
                <button mat-menu-item>Sky blue & bubblegum pink</button>
                <button mat-menu-item>Mustard, sage, & forest green</button>
                <button mat-menu-item>Fuchsia & neon green</button>
                <button mat-menu-item>Pastel orange, peach, & custard</button>
                <button mat-menu-item>Raspberry & shades of blue</button>
                <button mat-menu-item>Cherry red & bubblegum pink</button>
                <button mat-menu-item>Coral, spiced apple & peach</button>
                <button mat-menu-item>Light purple, mint, & butter</button>
                <button mat-menu-item>Forest green & moss green</button>
                <button mat-menu-item>Island green & white</button>
                <button mat-menu-item>Yellow & verdant green</button>
                <button mat-menu-item>Beige, black-brown, & tan </button>
                <button mat-menu-item>Royal blue & pale yellow</button>
                <button mat-menu-item>Blue, maroon, & indigo</button>
                <button mat-menu-item>Scarlet, light olive, & light teal</button> -->
              </mat-menu>
          </div>          
        </div>
      </div>
      <br />
    </mat-card-content>   
  </mat-card>
</div>
<app-version></app-version>

